<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Приложение 10</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <table class="table b-table table-bordered b-table-no-border-collapse">
                <thead>
                <tr class="sticky-thead1">
                    <th v-for="(field, index) in tableFields" class="text-center" :key="index">
                        <template v-if="field.key === 'action'">
                            <button type="button" class="btn btn-secondary" @click="toggleRowAll">
                                <i class="icon icon-chevron-circle"></i>
                            </button>
                        </template>
                        <template v-else>
                            {{ field.label }}
                        </template>
                    </th>
                </tr>
                <tr class="sticky-thead2">
                    <th class="text-center"></th>
                    <th class="text-center"></th>
                    <th v-for="number in 10" :key="number" class="text-center">{{ number }}</th>
                </tr>
                </thead>
                <tbody v-for="(row, index) in formApp10" :key="index" class="table-info">
                <tr class="text-right">
                    <!-- Parent Row -->
                    <td class="toggle-show">
                        <button type="button" class="btn btn-secondary" @click="toggleRow(index)">
                            <i class="icon icon-chevron-circle"></i>
                        </button>
                    </td>
                    <td>{{ row.parent_code }}</td>
                    <td>{{ row.name_ru }}</td>
                    <td v-if="row.column2">{{ $n(row.column2) }}</td>
                    <td v-else></td>
                    <td v-if="row.column3">{{ $n(row.column3) }}</td>
                    <td v-else></td>
                    <td v-if="row.column4">{{ $n(row.column4) }}</td>
                    <td v-else></td>
                    <td v-if="row.column5">{{ $n(row.column5) }}</td>
                    <td v-else></td>
                    <td>{{ row.rate }}</td>
                    <td v-if="row.column7">{{ $n(row.column7) }}</td>
                    <td v-else></td>
                    <td v-if="row.column8">{{ $n(row.column8) }}</td>
                    <td v-else></td>
                    <td v-if="row.column9">{{ $n(row.column9) }}</td>
                    <td v-else></td>
                    <td v-if="row.column10">{{ $n(row.column10) }}</td>
                    <td v-else></td>
                </tr>
                <template v-if="obl === '45' && openRows[index]">
                    <tr v-for="(child, childIndex) in row.child" :key="childIndex" class="text-right"
                        :style="{ backgroundColor: (child.code === '1.1' || child.code.endsWith('.0')) ? '#e8f4fa' : 'white' }">
                        <td></td>
                        <td v-if="child.code === '1.1'">{{ '1.1' }}</td>
                        <td v-else-if="child.parent_code.startsWith('1') && child.code.endsWith('.0')">{{child.parent_code}}</td>
                        <td v-else-if="/^[2-4]/.test(child.parent_code)">{{child.parent_code}}</td>
                        <td v-else></td>
                        <td>{{ child.name_ru }}</td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1'">
                            <input type="number" v-model="child.column2"
                                   @blur="blurInput45(child, 'column2')"
                                   @focus="child._prevValues = { ...child._prevValues, column2: child.column2 }"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion}"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td :style="{ backgroundColor: highlightCodes.includes(child.code) ? '#fef9ec' : '#e8f4fa' }"
                            v-else>{{$n(toNum(child.column2))}}</td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1' && !highlightCodes3.includes(child.code)">
                            <input type="number" v-model="child.column3"
                                   @blur="blurInput45(child, 'column3')"
                                   @focus="child._prevValues = { ...child._prevValues, column3: child.column3 }"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td :style="{ backgroundColor: highlightCodes3.includes(child.code) ? '#fef9ec' : '#e8f4fa'}"
                            v-else>{{$n(toNum(child.column3))}}</td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1'">
                            <input type="number" v-model="child.column4"
                                   @blur="blurInput45(child, 'column4')"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion}"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td v-else>{{$n(toNum(child.column4))}}</td>
                        <td v-if="child.column5">{{$n(child.column5)}}</td>
                        <td v-else></td>
                        <td v-if="child.rate">{{ child.rate + '%'}}</td>
                        <td v-else></td>
                        <td v-if="child.column7">{{$n(child.column7)}}</td>
                        <td v-else></td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1'">
                            <input type="number" v-model="child.column8"
                                   @blur="blurInput45(child, 'column8')"
                                   @focus="child._prevValues = { ...child._prevValues, column8: child.column8 }"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion}"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td :style="{ backgroundColor: highlightCodes.includes(child.code) ? '#fef9ec' : '#e8f4fa'}"
                            v-else>{{$n(toNum(child.column8))}}</td>
                        <td v-if="child.column9">{{$n(child.column9)}}</td>
                        <td v-else></td>
                        <td v-if="child.column10">{{$n(child.column10)}}</td>
                        <td v-else></td>
                    </tr>
                </template>
                <template v-if="obl !== '45' && openRows[index]">
                    <tr v-for="(child, childIndex) in row.child" :key="childIndex" class="text-right"
                        :style="{ backgroundColor: (child.code === '1.1' || child.code.endsWith('.0')) ? '#e8f4fa' : 'white' }">
                        <td></td>
                        <td v-if="child.code === '1.1'">{{ '1.1' }}</td>
                        <td v-else-if="child.parent_code.startsWith('1') && child.code.endsWith('.0')">{{child.parent_code}}</td>
                        <td v-else-if="/^[2-4]/.test(child.parent_code)">{{child.parent_code}}</td>
                        <td v-else></td>
                        <td>{{ child.name_ru }}</td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1' && !highlightCodes.includes(child.code)">
                            <input type="number" v-model="child.column2"
                                   @blur="blurInput(child, 'column2')"
                                   @focus="child._prevValues = { ...child._prevValues, column2: child.column2 }"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion}"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td :style="{ backgroundColor: highlightCodes.includes(child.code) ? '#fef9ec' : '#e8f4fa' }"
                            v-else>{{$n(toNum(child.column2))}}</td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1' && !highlightCodes3.includes(child.code)">
                            <input type="number" v-model="child.column3"
                                   @blur="blurInput(child, 'column3')"
                                   @focus="child._prevValues = { ...child._prevValues, column3: child.column3 }"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td :style="{ backgroundColor: highlightCodes3.includes(child.code) ? '#fef9ec' : '#e8f4fa'}"
                            v-else>{{$n(toNum(child.column3))}}</td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1'">
                            <input type="number" v-model="child.column4"
                                   @blur="blurInput(child, 'column4')"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion}"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td v-else>{{$n(toNum(child.column4))}}</td>
                        <td v-if="child.column5">{{$n(child.column5)}}</td>
                        <td v-else></td>
                        <td v-if="child.rate">{{ child.rate + '%'}}</td>
                        <td v-else></td>
                        <td v-if="child.column7">{{$n(child.column7)}}</td>
                        <td v-else></td>
                        <td v-if="!child.code.endsWith('.0') && child.code !== '1.1' && !highlightCodes.includes(child.code)">
                            <input type="number" v-model="child.column8"
                                   @blur="blurInput(child, 'column8')"
                                   @focus="child._prevValues = { ...child._prevValues, column8: child.column8 }"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion}"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </td>
                        <td :style="{ backgroundColor: highlightCodes.includes(child.code) ? '#fef9ec' : '#e8f4fa'}"
                            v-else>{{$n(toNum(child.column8))}}</td>
                        <td v-if="child.column9">{{$n(child.column9)}}</td>
                        <td v-else></td>
                        <td v-if="child.column10">{{$n(child.column10)}}</td>
                        <td v-else></td>
                    </tr>
                </template>
                </tbody>
                <tfoot>
                <tr class="text-right font-weight-bold" style="font-size: 15px">
                    <td></td>
                    <td></td>
                    <td><strong>Итого</strong></td>
                    <td>{{ $n(totalRow.column2) || '' }}</td>
                    <td>{{ $n(totalRow.column3) || '' }}</td>
                    <td>{{ $n(totalRow.column4) || '' }}</td>
                    <td>{{ $n(totalRow.column5) || '' }}</td>
                    <td></td>
                    <td><span
                        v-if="hasErrorPR10()"
                        :title="'Значение не соответствует контролю: строка 120, Форма ПКФО-2 = строка ИТОГО, Форма Приложение 10'"
                        class="warning-icon"
                    >⚠</span>{{ $n(totalRow.column7) || '' }}
                    </td>
                    <td>{{ $n(totalRow.column8) || '' }}</td>
                    <td>{{ $n(totalRow.column9) || '' }}</td>
                    <td>{{ $n(totalRow.column10) || '' }}</td>
                </tr>
                </tfoot>
            </table>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import moment from "moment/moment";
import {Ax} from "@/utils";

export default {
    name: 'forecast-app10',
    components: {
        'loading': VueElementLoading
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        radio_year: Number,
        actualVersion: Boolean,
        access_level: Number,
        obl: String,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            formApp10: [],
            formApp10notChange: [],
            loading: false,
            tableFields: [
                {
                    key: 'action',
                    label: ' ',
                    class: 'toggle-show'
                },
                {
                    key: 'num',
                    label: '№'
                },
                {
                    key: 'column1',
                    label: 'Наименование долгосрочных активов'
                },
                {
                    key: 'column2',
                    label: 'Сальдо на начало года по первоначальной стоимости, тыс тг'
                },
                {
                    key: 'column3',
                    label: 'Сумма поступления, тыс тг'
                },
                {
                    key: 'column4',
                    label: 'Сумма выбытия долгосрочных активов, тыс тг'
                },
                {
                    key: 'column5',
                    label: 'Сальдо на конец года по первоначальной стоимости, тыс тг (графы 2, 3, 4)'
                },
                {
                    key: 'column6',
                    label: 'Годовая норма износа в %'
                },
                {
                    key: 'column7',
                    label: 'Сумма начисленной амортизации, тыс тг (графы 5, 6)'
                },
                {
                    key: 'column8',
                    label: 'Сумма накопленной амортизации на начало года, тыс тг'
                },
                {
                    key: 'column9',
                    label: 'Сумма накопленной амортизации на конец года, тыс тг (графы 7, 8)'
                },
                {
                    key: 'column10',
                    label: 'Сальдо на конец года по балансовой стоимости, тыс тг (графы 5, 9)'
                }],
            openRows: {},
            originalValues: {},
            originalCancel: [],
            inputValues: [],
            inputApp7: [],
            highlightCodes: ['1.2', '1.2.1', '1.3.1', '1.4.3', '1.5.1', '1.6.1', '1.7.5'],
            highlightCodes3: ['1.2', '1.4.3', '1.5.1', '1.7.5', '3.1.1', '4.1.1'],
            totalRow: {
                column2: 0,
                column3: 0,
                column4: 0,
                column5: 0,
                rate: null,
                column7: 0,
                column8: 0,
                column9: 0,
                column10: 0,
            },
        }
    },
    async mounted() {
        await this.LoadApp10(this.radio_year, 'first');
        this.formApp10.forEach((row, index) => {
            this.$set(this.openRows, index, true);
        });
    },
    created() {
        this.$on('activateEditMode', this.setEditMode);
    },
    computed: {
        forecastYears() {
            return [this.year - 1, this.year, this.year + 1, this.year + 2];
        }
    },
    watch: {
        radio_year() {
            this.inputValues = [];
        }
    },
    methods: {
        hasErrorPR10() {
            return this.checkDataList.find(item => {
                if (item.agreed_form !== 'PR10') return false;

                // проверяем все возможные поля
                const fieldMap = {
                    evaluation: this.year - 1,
                    forecast_1: this.year,
                    forecast_2: this.year + 1,
                    forecast_3: this.year + 2,
                };

                // ищем, есть ли совпадение
                return Object.entries(fieldMap).some(([field, year]) => {
                    return item[field] && year === this.radio_year;
                });
            });
        },
        formatDecimal(child, field) {
            let value = child[field].toString();
            if (value.includes('.')) {
                value = value.replace(/(\.\d).*/, '$1'); // Keep only one digit after '.'
            }
            child[field] = value;
        },
        blurInput(child, data, isInitialLoad = false) {
            let parsedValue;
            if (child[data] === undefined || child[data] === null || child[data] === "") {
                parsedValue = null;
            } else {
                parsedValue = parseFloat(child[data]) || 0;
            }

            const codeMap = {'1': '1.2', '1.3': '1.3.1', '1.4': '1.4.3', '1.5': '1.5.1', '1.6': '1.6.1', '1.7': '1.7.5', '2.2': '2.1.1'};
            const column3Map = {'1': '1.2', '1.2': '1.2', '1.3': '1.2', '1.4': '1.4.3', '1.5': '1.5.1', '1.6': '1.5.1', '1.7': '1.7.5', '3.2': '3.1.1', '4.2': '4.1.1', '4.3': '4.1.1', '4.4': '4.1.1', '4.5': '4.1.1'};

            const parentCode = child.parent_code;
            const index = parseInt(parentCode[0], 10) - 1;

            const parentMappedCode = codeMap[child.parent_code];
            const parentRow = this.formApp10[index].child.find(child => child.code === parentMappedCode);
            const childRow = this.formApp10notChange[index].child.find(data => data.code === child.code);

            const parentMappedCode3 = column3Map[child.parent_code];
            const parentRow3 = this.formApp10[index].child.find(child => child.code === parentMappedCode3);

            if (!isInitialLoad && child.parent_code && codeMap[child.parent_code] && (data === 'column2' || data === 'column8')) {
                const parentMappedCode = codeMap[child.parent_code];
                const parentRow = this.formApp10[index].child.filter(child => child.code === parentMappedCode)[0];
                if (parentRow) {
                    const newRaw = child[data];
                    const wasCleared = typeof newRaw === 'string' && newRaw.trim() === '';

                    const oldChildValue = parseFloat(child._prevValues?.[data]) || 0;
                    const newChildValue = parseFloat(newRaw) || 0;
                    const parentValue = parseFloat(parentRow[data]) || 0;
                    const oldChildValued = parseFloat(childRow?.[data]) || 0;

                    let result;
                    if (wasCleared) {
                        result = parentValue + oldChildValue;
                    } else if (newChildValue === 0 && childRow?.[data] !== undefined) {
                        result = parentValue + oldChildValued;
                    } else {
                        result = parentValue - (newChildValue - oldChildValue);
                    }
                    this.$set(parentRow, data, result);
                }
            }

            if (!isInitialLoad && child.parent_code && column3Map[child.parent_code] && data === 'column3') {
                const parentMappedCode3 = column3Map[child.parent_code];
                const parentRow3 = this.formApp10[index].child.find(child => child.code === parentMappedCode3);
                if (parentRow3) {
                    const newRaw = child[data];
                    const wasCleared = typeof newRaw === 'string' && newRaw.trim() === '';

                    const oldChildValue = parseFloat(child._prevValues?.[data]) || 0;
                    const newChildValue = parseFloat(newRaw) || 0;
                    const parentValue = parseFloat(parentRow3[data]) || 0;
                    const oldChildValued = parseFloat(childRow?.[data]) || 0;

                    let result;
                    if (wasCleared) {
                        result = parentValue + oldChildValue;
                    } else if (newChildValue === 0 && childRow?.[data] !== undefined) {
                        result = parentValue + oldChildValued;
                    } else {
                        result = parentValue - (newChildValue - oldChildValue);
                    }
                    this.$set(parentRow3, data, result);
                }

            }

            if (!isInitialLoad && parentRow && data !== 'column4') {
                const existingEntryIndex = this.inputValues.findIndex(entry => entry.code === parentRow.code);
                if (existingEntryIndex !== -1) {
                    // Update the specific field for an existing entry
                    this.$set(this.inputValues[existingEntryIndex], data, parentRow[data]);
                } else if (parentRow[data] !== null) {
                    const newEntry = {
                        code: parentRow.code,
                        [data]: parentRow[data]
                    };
                    this.inputValues.push(newEntry);
                }
            }
            const col2 = parseFloat(child.column2) || 0;
            const col3 = parseFloat(child.column3) || 0;
            const col4 = parseFloat(child.column4) || 0;
            const col8 = parseFloat(child.column8) || 0;

            if (!isInitialLoad && parentRow && (data === 'column2' || data === 'column8')) {
                const colp2 = parseFloat(parentRow.column2) || 0;
                const colp3 = parseFloat(parentRow.column3) || 0;
                const colp4 = parseFloat(parentRow.column4) || 0;
                const colp8 = parseFloat(parentRow.column8) || 0;

                const resultp5 = colp2 + colp3 - colp4;
                this.$set(parentRow, 'column5', this.toNum(resultp5));

                const resultp7 = resultp5 * parentRow.rate/100;
                this.$set(parentRow, 'column7', this.toNum(resultp7));

                const resultp9 = resultp7 + colp8;
                this.$set(parentRow, 'column9', this.toNum(resultp9));

                const resultp10 = resultp5 - resultp9;
                this.$set(parentRow, 'column10', this.toNum(resultp10));
            }
            if (!isInitialLoad && parentRow3 && data === 'column3') {
                const colp2 = parseFloat(parentRow3.column2) || 0;
                const colp3 = parseFloat(parentRow3.column3) || 0;
                const colp4 = parseFloat(parentRow3.column4) || 0;
                const colp8 = parseFloat(parentRow3.column8) || 0;
                const resultp5 = colp2 + colp3 - colp4;
                this.$set(parentRow3, 'column5', this.toNum(resultp5));

                const resultp7 = resultp5 * parentRow3.rate/100;
                this.$set(parentRow3, 'column7', this.toNum(resultp7));

                const resultp9 = resultp7 + colp8;
                this.$set(parentRow3, 'column9', this.toNum(resultp9));

                const resultp10 = resultp5 - resultp9;
                this.$set(parentRow3, 'column10', this.toNum(resultp10));
            }
            const result5 = col2 + col3 - col4;
            this.$set(child, 'column5', this.toNum(result5));

            const result7 = result5 * child.rate/100;
            this.$set(child, 'column7', this.toNum(result7));

            const result9 = result7 + col8;
            this.$set(child, 'column9', this.toNum(result9));

            const result10 = result5 - result9;
            this.$set(child, 'column10', this.toNum(result10));

            const existingEntryIndex = this.inputValues.findIndex(entry => entry.code === child.code);
            const isForbiddenCode = child.code === '1.1' || child.code.endsWith('.0');
            if (existingEntryIndex !== -1) {
                // Update the specific field for an existing entry
                this.$set(this.inputValues[existingEntryIndex], data, parsedValue);
                this.$set(this.inputValues[existingEntryIndex], 'column5', this.toNum(result5));
                this.$set(this.inputValues[existingEntryIndex], 'column9', this.toNum(result9));
            } else if (parsedValue !== null && !isForbiddenCode) {
                // Create a new entry if it doesn't exist and the value is not null
                const newEntry = {
                    code: child.code,
                    column2: data === 'column2' ? parsedValue : null,
                    column3: data === 'column3' ? parsedValue : null,
                    column4: data === 'column4' ? parsedValue : null,
                    column5: this.toNum(result5),
                    column8: data === 'column8' ? parsedValue : null,
                    column9: this.toNum(result9)
                };
                this.inputValues.push(newEntry);
            }

            if (!isInitialLoad && parentRow) {
                const parentExistingIndex = this.inputValues.findIndex(entry => entry.code === parentRow.code);
                if (parentExistingIndex !== -1) {
                    this.$set(this.inputValues[parentExistingIndex], 'column5', this.toNum(parentRow.column5));
                    this.$set(this.inputValues[parentExistingIndex], 'column9', this.toNum(parentRow.column9));
                } else {
                    this.inputValues.push({
                        code: parentRow.code,
                        column5: this.toNum(parentRow.column5),
                        column9: this.toNum(parentRow.column9)
                    });
                }
            }

            const sumField = (rows, field) =>
                this.toNum(rows.reduce((acc, row) => {
                    const val = parseFloat(row[field]) || 0;
                    if (field === 'column10' && val < 0) return acc;
                    return acc + val;
                }, 0));

            const setSums = (target, rows, fields) => {
                fields.forEach(field => {
                    this.$set(target, field, sumField(rows, field));
                });
            };

            const sumFields = ['column5', 'column7', 'column9', 'column10', data];

            // Main Row and Sum Rows
            let mainRow, sumRows;
            if (index > 0) {
                mainRow = this.formApp10[index];
                sumRows = mainRow.child;
            } else {
                const children = this.formApp10[index].child;
                mainRow = children.find(child => child.parent_code === parentCode && (child.code.endsWith('.0') || child.code === '1.1'));
                sumRows = children.filter(child => child.parent_code === parentCode && !child.code.endsWith('.0') && child.code !== '1.1');
            }

            if (mainRow && sumRows) {
                setSums(mainRow, sumRows, sumFields);
            }
            // Formula for colomn3 when spf = 412
            if (data === 'column3' && (child.code.startsWith('1.3') || child.code === '1.2.1')) {
                const allRows = this.formApp10[index].child;
                const mainRow11 = allRows.find(row => row.code === '1.1');
                const sumRows11 = allRows.filter(row => row.code === '1.2' || row.code === '1.3');
                if (mainRow11 && sumRows11.length > 0) {
                    setSums(mainRow11, sumRows11, sumFields);
                }
                const updatedRow12 = allRows.find(row => row.code === '1.2');
                if (updatedRow12) {
                    const updatedValue = parseFloat(updatedRow12[data]) || null;
                    const idx = this.inputValues.findIndex(entry => entry.code === '1.2');
                    if (idx !== -1) {
                        this.$set(this.inputValues[idx], data, updatedValue);
                    } else if (updatedValue !== null) {
                        this.inputValues.push({
                            code: '1.2',
                            column3: data === 'column3' ? updatedValue : null
                        });
                    }
                }
            }
            // Formula for colomn3 when spf = 414
            if (data === 'column3' && child.code.startsWith('1.6')) {
                const allRows = this.formApp10[index].child;
                const mainRow15 = allRows.find(row => row.code === '1.5.0');
                const sumRows15 = allRows.filter(row => row.parent_code === '1.5' && row.code !== '1.5.0');
                if (mainRow15 && sumRows15.length > 0) {
                    setSums(mainRow15, sumRows15, sumFields);
                }
                const updatedRow15 = allRows.find(row => row.code === '1.5.1');
                if (updatedRow15) {
                    const updatedValue = parseFloat(updatedRow15[data]) || null;
                    const idx = this.inputValues.findIndex(entry => entry.code === '1.5.1');
                    if (idx !== -1) {
                        this.$set(this.inputValues[idx], data, updatedValue);
                    } else if (updatedValue !== null) {
                        this.inputValues.push({
                            code: '1.5.1',
                            column3: data === 'column3' ? updatedValue : null
                        });
                    }
                }
            }

            // First group sums
            const mainArray1 = this.formApp10[0];
            const sumArray1 = mainArray1.child.filter(
                child => child.code.endsWith('.0') || child.code === '1.1' || child.code === '1.2.1'
            );
            if (mainArray1 && sumArray1) {
                setSums(mainArray1, sumArray1, sumFields);
            }
            // Total sums
            const totalArray = this.formApp10;
            setSums(this.totalRow, totalArray, sumFields);
        },
        blurInput45(child, data, isInitialLoad = false) {
            let parsedValue;
            if (child[data] === undefined || child[data] === null || child[data] === "") {
                parsedValue = null;
            } else {
                parsedValue = parseFloat(child[data]) || 0;
            }

            const codeMap = {'1': '1.2', '1.3': '1.3.1', '1.4': '1.4.3', '1.5': '1.5.1', '1.6': '1.6.1', '1.7': '1.7.5', '2.2': '2.1.1'};
            const column3Map = {'1': '1.2', '1.2': '1.2', '1.3': '1.2', '1.4': '1.4.3', '1.5': '1.5.1', '1.6': '1.5.1', '1.7': '1.7.5', '3.2': '3.1.1', '4.2': '4.1.1', '4.3': '4.1.1', '4.4': '4.1.1', '4.5': '4.1.1'};

            const parentCode = child.parent_code;
            const index = parseInt(parentCode[0], 10) - 1;

            const parentMappedCode = codeMap[child.parent_code];
            const parentRow = this.formApp10[index].child.find(child => child.code === parentMappedCode);
            const childRow = this.formApp10notChange[index].child.find(data => data.code === child.code);

            const parentMappedCode3 = column3Map[child.parent_code];
            const parentRow3 = this.formApp10[index].child.find(child => child.code === parentMappedCode3);

            // if (!isInitialLoad && child.parent_code && codeMap[child.parent_code] && (data === 'column2' || data === 'column8')) {
            //     const parentMappedCode = codeMap[child.parent_code];
            //     const parentRow = this.formApp10[index].child.filter(child => child.code === parentMappedCode)[0];
            //     if (parentRow) {
            //         const newRaw = child[data];
            //         const wasCleared = typeof newRaw === 'string' && newRaw.trim() === '';
            //
            //         const oldChildValue = parseFloat(child._prevValues?.[data]) || 0;
            //         const newChildValue = parseFloat(newRaw) || 0;
            //         const parentValue = parseFloat(parentRow[data]) || 0;
            //         const oldChildValued = parseFloat(childRow?.[data]) || 0;
            //
            //         let result;
            //         if (wasCleared) {
            //             result = parentValue + oldChildValue;
            //         } else if (newChildValue === 0 && childRow?.[data] !== undefined) {
            //             result = parentValue + oldChildValued;
            //         } else {
            //             result = parentValue - (newChildValue - oldChildValue);
            //         }
            //         this.$set(parentRow, data, result);
            //     }
            // }

            if (!isInitialLoad && child.parent_code && column3Map[child.parent_code] && data === 'column3') {
                const parentMappedCode3 = column3Map[child.parent_code];
                const parentRow3 = this.formApp10[index].child.find(child => child.code === parentMappedCode3);
                if (parentRow3) {
                    const newRaw = child[data];
                    const wasCleared = typeof newRaw === 'string' && newRaw.trim() === '';

                    const oldChildValue = parseFloat(child._prevValues?.[data]) || 0;
                    const newChildValue = parseFloat(newRaw) || 0;
                    const parentValue = parseFloat(parentRow3[data]) || 0;
                    const oldChildValued = parseFloat(childRow?.[data]) || 0;

                    let result;
                    if (wasCleared) {
                        result = parentValue + oldChildValue;
                    } else if (newChildValue === 0 && childRow?.[data] !== undefined) {
                        result = parentValue + oldChildValued;
                    } else {
                        result = parentValue - (newChildValue - oldChildValue);
                    }
                    this.$set(parentRow3, data, result);
                }

            }

            if (!isInitialLoad && parentRow && data !== 'column4') {
                const existingEntryIndex = this.inputValues.findIndex(entry => entry.code === parentRow.code);
                if (existingEntryIndex !== -1) {
                    // Update the specific field for an existing entry
                    this.$set(this.inputValues[existingEntryIndex], data, parentRow[data]);
                } else if (parentRow[data] !== null) {
                    const newEntry = {
                        code: parentRow.code,
                        [data]: parentRow[data]
                    };
                    this.inputValues.push(newEntry);
                }
            }
            const col2 = parseFloat(child.column2) || 0;
            const col3 = parseFloat(child.column3) || 0;
            const col4 = parseFloat(child.column4) || 0;
            const col8 = parseFloat(child.column8) || 0;

            if (!isInitialLoad && parentRow && (data === 'column2' || data === 'column8')) {
                const colp2 = parseFloat(parentRow.column2) || 0;
                const colp3 = parseFloat(parentRow.column3) || 0;
                const colp4 = parseFloat(parentRow.column4) || 0;
                const colp8 = parseFloat(parentRow.column8) || 0;

                const resultp5 = colp2 + colp3 - colp4;
                this.$set(parentRow, 'column5', this.toNum(resultp5));

                const resultp7 = resultp5 * parentRow.rate/100;
                this.$set(parentRow, 'column7', this.toNum(resultp7));

                const resultp9 = resultp7 + colp8;
                this.$set(parentRow, 'column9', this.toNum(resultp9));

                const resultp10 = resultp5 - resultp9;
                this.$set(parentRow, 'column10', this.toNum(resultp10));
            }
            if (!isInitialLoad && parentRow3 && data === 'column3') {
                const colp2 = parseFloat(parentRow3.column2) || 0;
                const colp3 = parseFloat(parentRow3.column3) || 0;
                const colp4 = parseFloat(parentRow3.column4) || 0;
                const colp8 = parseFloat(parentRow3.column8) || 0;
                const resultp5 = colp2 + colp3 - colp4;
                this.$set(parentRow3, 'column5', this.toNum(resultp5));

                const resultp7 = resultp5 * parentRow3.rate/100;
                this.$set(parentRow3, 'column7', this.toNum(resultp7));

                const resultp9 = resultp7 + colp8;
                this.$set(parentRow3, 'column9', this.toNum(resultp9));

                const resultp10 = resultp5 - resultp9;
                this.$set(parentRow3, 'column10', this.toNum(resultp10));
            }
            const result5 = col2 + col3 - col4;
            this.$set(child, 'column5', this.toNum(result5));

            const result7 = result5 * child.rate/100;
            this.$set(child, 'column7', this.toNum(result7));

            const result9 = result7 + col8;
            this.$set(child, 'column9', this.toNum(result9));

            const result10 = result5 - result9;
            this.$set(child, 'column10', this.toNum(result10));

            const existingEntryIndex = this.inputValues.findIndex(entry => entry.code === child.code);
            const isForbiddenCode = child.code === '1.1' || child.code.endsWith('.0');
            if (existingEntryIndex !== -1) {
                // Update the specific field for an existing entry
                this.$set(this.inputValues[existingEntryIndex], data, parsedValue);
                this.$set(this.inputValues[existingEntryIndex], 'column5', this.toNum(result5));
                this.$set(this.inputValues[existingEntryIndex], 'column9', this.toNum(result9));
            } else if (parsedValue !== null && !isForbiddenCode) {
                // Create a new entry if it doesn't exist and the value is not null
                const newEntry = {
                    code: child.code,
                    column2: data === 'column2' ? parsedValue : null,
                    column3: data === 'column3' ? parsedValue : null,
                    column4: data === 'column4' ? parsedValue : null,
                    column5: this.toNum(result5),
                    column8: data === 'column8' ? parsedValue : null,
                    column9: this.toNum(result9)
                };
                this.inputValues.push(newEntry);
            }

            if (!isInitialLoad && parentRow) {
                const parentExistingIndex = this.inputValues.findIndex(entry => entry.code === parentRow.code);
                if (parentExistingIndex !== -1) {
                    this.$set(this.inputValues[parentExistingIndex], 'column5', this.toNum(parentRow.column5));
                    this.$set(this.inputValues[parentExistingIndex], 'column9', this.toNum(parentRow.column9));
                } else {
                    this.inputValues.push({
                        code: parentRow.code,
                        column5: this.toNum(parentRow.column5),
                        column9: this.toNum(parentRow.column9)
                    });
                }
            }

            const sumField = (rows, field) =>
                this.toNum(rows.reduce((acc, row) => {
                    const val = parseFloat(row[field]) || 0;
                    if (field === 'column10' && val < 0) return acc;
                    return acc + val;
                }, 0));

            const setSums = (target, rows, fields) => {
                fields.forEach(field => {
                    this.$set(target, field, sumField(rows, field));
                });
            };

            const sumFields = ['column5', 'column7', 'column9', 'column10', data];

            // Main Row and Sum Rows
            let mainRow, sumRows;
            if (index > 0) {
                mainRow = this.formApp10[index];
                sumRows = mainRow.child;
            } else {
                const children = this.formApp10[index].child;
                mainRow = children.find(child => child.parent_code === parentCode && (child.code.endsWith('.0') || child.code === '1.1'));
                sumRows = children.filter(child => child.parent_code === parentCode && !child.code.endsWith('.0') && child.code !== '1.1');
            }

            if (mainRow && sumRows) {
                setSums(mainRow, sumRows, sumFields);
            }
            // Formula for colomn3 when spf = 412
            if (data === 'column3' && (child.code.startsWith('1.3') || child.code === '1.2.1')) {
                const allRows = this.formApp10[index].child;
                const mainRow11 = allRows.find(row => row.code === '1.1');
                const sumRows11 = allRows.filter(row => row.code === '1.2' || row.code === '1.3');
                if (mainRow11 && sumRows11.length > 0) {
                    setSums(mainRow11, sumRows11, sumFields);
                }
                const updatedRow12 = allRows.find(row => row.code === '1.2');
                if (updatedRow12) {
                    const updatedValue = parseFloat(updatedRow12[data]) || null;
                    const idx = this.inputValues.findIndex(entry => entry.code === '1.2');
                    if (idx !== -1) {
                        this.$set(this.inputValues[idx], data, updatedValue);
                    } else if (updatedValue !== null) {
                        this.inputValues.push({
                            code: '1.2',
                            column3: data === 'column3' ? updatedValue : null
                        });
                    }
                }
            }
            // Formula for colomn3 when spf = 414
            if (data === 'column3' && child.code.startsWith('1.6')) {
                const allRows = this.formApp10[index].child;
                const mainRow15 = allRows.find(row => row.code === '1.5.0');
                const sumRows15 = allRows.filter(row => row.parent_code === '1.5' && row.code !== '1.5.0');
                if (mainRow15 && sumRows15.length > 0) {
                    setSums(mainRow15, sumRows15, sumFields);
                }
                const updatedRow15 = allRows.find(row => row.code === '1.5.1');
                if (updatedRow15) {
                    const updatedValue = parseFloat(updatedRow15[data]) || null;
                    const idx = this.inputValues.findIndex(entry => entry.code === '1.5.1');
                    if (idx !== -1) {
                        this.$set(this.inputValues[idx], data, updatedValue);
                    } else if (updatedValue !== null) {
                        this.inputValues.push({
                            code: '1.5.1',
                            column3: data === 'column3' ? updatedValue : null
                        });
                    }
                }
            }

            // First group sums
            const mainArray1 = this.formApp10[0];
            const sumArray1 = mainArray1.child.filter(
                child => child.code.endsWith('.0') || child.code === '1.1' || child.code === '1.2.1'
            );
            if (mainArray1 && sumArray1) {
                setSums(mainArray1, sumArray1, sumFields);
            }
            // Total sums
            const totalArray = this.formApp10;
            setSums(this.totalRow, totalArray, sumFields);
        },
        async LoadApp10(radio_year, answer) {
            this.totalRow = {column2: 0, column3: 0, column4: 0, column5: 0, rate: null, column7: 0, column8: 0, column9: 0, column10: 0};
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_dict_items_appendix10/` + radio_year + '/' + this.version + '/' + this.abp + '/' + this.year + '/' + this.region + '/' + this.obl + '/' + answer);
                if (response.status === 200) {
                    const data = await response.json();
                    if (answer === 'first' || answer === 'Yes'){
                        this.formApp10 = data.result;
                    }
                    if (answer === 'YesFinTab') {
                        const finTab = data.fintab;
                        this.formApp10.forEach(item => {
                            item.child.forEach(childItem => {
                                const updated = finTab[childItem.code];
                                if (updated) {
                                    childItem.column2 = updated.column2;
                                    childItem.column8 = updated.column8;
                                } else {
                                    childItem.column2 = null;
                                    childItem.column8 = null;
                                }
                            });
                        });
                    }
                    if (answer === 'YesApp7') {
                        const App7 = data.app7;
                        this.formApp10.forEach(item => {
                            item.child.forEach(childItem => {
                                const updated = App7[childItem.code];
                                if (updated) {
                                    childItem.column3 = updated.column3;
                                } else {
                                    childItem.column3 = null;
                                }
                            });
                        });
                    }
                    this.formApp10notChange = JSON.parse(JSON.stringify(data.result));
                    if (data.checkEmpty === 0 && answer === 'first') {
                        this.$emit('openModal');
                        this.$emit('checkImpInput', false);
                    } else {
                        this.$emit('checkImpInput', true);
                    }
                    this.formApp10.forEach(row => {
                        row.child.forEach(child => {
                            if ('column2' in child) {
                                this.blurInput(child, 'column2', true);
                            }
                            if ('column3' in child) {
                                this.blurInput(child, 'column3', true);
                            }
                            if ('column4' in child) {
                                this.blurInput(child, 'column4', true);
                            }
                            if ('column8' in child) {
                                this.blurInput(child, 'column8', true);
                            }
                        });
                    });
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка Приложение 10', error.toString());
            }
            this.loading = false;
        },
        async SaveData() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'abp_code', this.abp);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'code_form', 'PR10');
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.$set(item, 'radio_year', this.radio_year);
                this.$set(item, 'pkfo_type', 'abp');
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_appendix10', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }

        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, abp: this.abp, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name, radio_year: this.radio_year, obl: this.obl };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_download_app10/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Приложение 10.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toggleRow(index) {
            this.$set(this.openRows, index, !this.openRows[index]);
        },
        toggleRowAll() {
            const allOpen = Object.values(this.openRows).every(v => v === true);

            this.formApp10.forEach((row, index) => {
                this.$set(this.openRows, index, !allOpen);
            });
        },
        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>
<style>
.sticky-thead1 {
    position: sticky;
    top: 40px;
    height: 120px;
    background-color: #fff;
    z-index: 10;
}

.sticky-thead2 {
    position: sticky;
    top: 160px;
    background-color: #fff;
    z-index: 10;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.disabled-input {
    background-color: #e9ecef !important;
}

</style>